var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fb-container",domProps:{"innerHTML":_vm._s(_vm.src)}})
}
var staticRenderFns = []

export { render, staticRenderFns }